import { Public_Sans } from "next/font/google";
import "./globals.css";
import "overlayscrollbars/overlayscrollbars.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ThemeProvider from "theme/theme-provider";
import CartProvider from "contexts/CartContext";
import AuthProvider from "contexts/AuthContext";
import SettingsProvider from "contexts/SettingContext";
import ProgressBar from "components/progress";
import "i18n";
import MiniCartDrawer from "./@modal/(.)mini-cart/page";
import { MiniCartProvider } from "contexts/MiniCartContext";
import ServiceWorkerRegistrar from "@/components/ServiceWorkerRegistrar";
import PWAInstallBanner from "@/components/PWAInstallBanner";

export const publicSans = Public_Sans({
  subsets: ["latin"],
  weight: ["300", "400", "500", "600", "700"]
});


export const viewport = {
  themeColor: '#D4251C',
  width: 'device-width',
  initialScale: 1,
  minimumScale: 1,
  maximumScale: 1,
};

export default function RootLayout({
  children,
  modal
}) {
  return <html lang="en" translate="no" suppressHydrationWarning>
    <head>
      <link rel="manifest" href="/manifest.json" />
      <link rel="apple-touch-icon" href="/icons/apple-touch-icon.png" />
    </head>
    <body id="body" className={publicSans.className}>
      <AuthProvider>
        <CartProvider>
          <SettingsProvider>
            <ThemeProvider>
              <ProgressBar />
              <ServiceWorkerRegistrar />
              <PWAInstallBanner />
              <MiniCartProvider>
                {modal}
                {children}
                <MiniCartDrawer />
              </MiniCartProvider>
            </ThemeProvider>
          </SettingsProvider>
        </CartProvider>
      </AuthProvider>
    </body>
  </html>;
}
